import moment from "moment";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { Request } from "../../../../types/models/manufacturingRoutes.model.type";
import { MyFilterRequest } from "../../../../types/request/myRequest.type";
import { FilterOptionsMyRequest, MyRequestState } from "../../../../types/states/myRequest.state.type";

const initialState: MyRequestState = {
  isFetching: false,
  data: [],
  error: undefined,
  selectedItem: undefined,
  filterOptions: {
    rangeDate: [moment().startOf("month"), moment()],
    stateMachineId: undefined,
    numberRequest: '',
  },
  request: undefined,
};

const myRequestSlice = createSlice({
  name: "myRequest",
  initialState,
  reducers: {
    rxStartFetching: (state) => {
      state.selectedItem = undefined;
      state.data = [];
      state.isFetching = true;
    },
    rxSuccessFetchingData: (state, { payload }: PayloadAction<Request[]>) => {
      state.isFetching = false;
      state.data = payload;
      state.error = undefined;
      if (state.selectedItem) {
        const foundSelected = payload.find((e) => e.recordDetailId === state.selectedItem!.recordDetailId);
        if (!foundSelected) {
          state.selectedItem = undefined;
        } else {
          state.selectedItem = foundSelected;
        }
      }
    },
    rxErrorFetchingData: (state, { payload }: PayloadAction<string>) => {
      state.isFetching = false;
      state.data = [];
      state.error = payload;
    },
    rxSetFilterOptions: (state, { payload }: PayloadAction<FilterOptionsMyRequest>) => {
      state.filterOptions = payload;
    },
    rxSetRequest: (state, { payload }: PayloadAction<MyFilterRequest>) => {
      state.request = payload;
    },
    rxResetFilter: (state) => {
      state.filterOptions = {
        rangeDate: [moment().startOf("month"), moment()],
        stateMachineId: undefined,
        numberRequest: '',
      };
    },
  },
});

export const {
  rxErrorFetchingData,
  rxResetFilter,
  rxSetFilterOptions,
  rxSetRequest,  
  rxStartFetching,
  rxSuccessFetchingData,
} = myRequestSlice.actions;
export const myRequestSelector = (state: { myRequest: MyRequestState }) => state.myRequest;
export default myRequestSlice.reducer;
